import React from 'react';
import HeroImageContainer from './HeroImageContainer';
import HeroText from './HeroText';
import styles from './HeroContent.module.css';

const HeroContent = () => {
    return (
        <div className={styles.heroContent}>
            <HeroImageContainer />
            <HeroText />
        </div>
    );
};

export default HeroContent;